import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";
import { generalInstractionGynac } from "../services/EMRServices/emrServices";

export default function Instruction(props) {
  const {
    instractionDataResult,
    setInstractionDataResult,
    instraction,
    setInstraction,
    dataInstruction,
    setDataInstruction,
    markFavoriteData,
    isENT,
  } = props;

  const [matchString, setMatchString] = React.useState("");
  const [instractionValue, setInstractionValue] = useState(null);
  const [instractionOption, setInstractionOption] = useState([]);
  React.useEffect(() => {
    if (dataInstruction?.length > 0) {
      let string = "";
      for (let dataObject of dataInstruction) {
        string = string + dataObject.instruction;
        setMatchString(string);
      }
    }
  }, [dataInstruction]);
  const handleChange = (e) => {
    if (e !== undefined && e !== "") {
      generalInstractionGynac(
        props.patientVisitedDepartmentId,
        props.doctorId,
        e,
      ).then((response) => {
        setInstractionOption(response.data.result);
      });
    } else if (e === "" || e === undefined || e === null) {
      setInstractionOption([]);
    }
  };
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({});

  const handleCheckboxChange = (instructionObj, isChecked) => {
    setInstractionDataResult((prev) => {
      if (isChecked) {
        return [...prev, instructionObj];
      } else {
        return prev.filter(
          (item) => item.instruction !== instructionObj.instruction,
        );
      }
    });
  };

  useEffect(() => {
    if (markFavoriteData?.generalInstructions?.length > 0) {
      let modifiedData = [];
      for (let instruction of markFavoriteData?.generalInstructions) {
        let instructionObject = {
          id: instruction.id,
          instruction: instruction.label,
          instruction: instruction.label,
        };
        modifiedData.push(instructionObject);
      }

      setDataInstruction(modifiedData);
    }
  }, [markFavoriteData?.generalInstructions]);

  function deleteRow(index) {
    const newComplaintsData = [...dataInstruction];
    newComplaintsData.splice(index, 1);
    setDataInstruction(newComplaintsData);
  }

  let instruction = watch("instruction");

  useEffect(() => {
    if (
      instruction !== null &&
      instruction !== undefined &&
      instruction !== undefined
    ) {
      let obj = {
        instruction: instruction?.label,
        isNew:
          instruction?.__isNew__ !== undefined &&
          instruction?.__isNew__ === true
            ? true
            : false,
      };
      let temp = dataInstruction.some(
        (item) => item?.instruction === instruction?.label,
      );
      if (temp === true) {
        warningAlert("Already Present Record..!");
      } else {
        if (instruction !== null && instruction !== undefined) {
          setDataInstruction((prevState) => [...prevState, obj]);
          setInstractionDataResult((prevState) => [...prevState, obj]);
          setValue("instruction", null);
        }
      }
    }
  }, [instruction]);
  const uniqueInstructions = dataInstruction.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t.instruction === value.instruction),
  );
  return (
    <div>
      <div className="flex justify-between bg-[#efd6ff] rounded-t-md ">
        <div className="flex gap-2">
          <p className="text-sm font-semibold pt-1 pl-1">General Instruction</p>
        </div>

        <div className="flex my-auto w-72">
          <fieldset
            className="w-full flex gap-2"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <SearchDropdown
              control={control}
              name="instruction"
              label="Instruction"
              placeholder="Instruction"
              dataArray={instractionOption}
              isSearchable={true}
              handleChange={handleChange}
              onInputChange={handleChange}
              inputRef={{
                ...register("instruction", {
                  onChange: (e) => {
                    setInstractionValue(e.target.value);
                  },
                }),
              }}
              // autoFocus
            />
          </fieldset>
        </div>
      </div>
      <div
        className={` ${
          props.from === "ent"
            ? "max-h-44 min-h-24"
            : props.from === "cardiology"
              ? "max-h-44 min-h-24"
              : "max-h-32 min-h-24"
        } border overflow-auto  border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md   `}
      >
        <div>
          <table className=" w-full">
            <tbody>
              {uniqueInstructions?.map((row, index) => {
                return (
                  <tr className="flex gap-2">
                    <td className="">
                      <input
                        type="checkbox"
                        name={`instraction${index}`}
                        onChange={(e) =>
                          handleCheckboxChange(row, e.target.checked)
                        }
                        defaultChecked={instractionDataResult.some(
                          (item) => item.instruction === row.instruction,
                        )}
                      />
                    </td>
                    <td className="w-full">
                      <label className="font-normal text-left ">
                        {row.instruction}
                      </label>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
